import React from 'react';
import { Grid, Typography, Paper, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {

    },
    paper: {

        backgroundColor: '#F5F5F5',
        borderRadius: 8,
        paddingLeft: "16px",
        paddingTop: "13px",
        marginBottom: "20px"
    },
    fieldContainer: {
        marginBottom: '13px',
    },
}));


const InfoDetails = ({ generalDetails, md, ...props }) => {
    const classes = useStyles();

    return (
        <>

            <Grid container className={classes.paper}>
                {generalDetails.map((item, index) => (
                    <Grid item xs={11} sm={6} md={md ?? 4} key={index} className={classes.fieldContainer} container>
                        <Grid item xs={4}>
                            <Typography className={classes.label} color='primary' variant="body2">
                                {item.label}
                            </Typography>
                        </Grid>
                        <Grid item xs={7}>

                            <Typography variant="body2">{item.value ?? "-"}</Typography></Grid>


                    </Grid>

                ))}
                <Grid item xs={1}>
                    {props?.children && props?.children}
                </Grid>
            </Grid>

        </>
    );
};

export default InfoDetails;
